import request from '@/utils/request'

/**
 * 获取进货统计列表
 * @param {Object} params - 请求参数
 * @returns {Promise} 返回进货统计列表的Promise对象
 */
export function getInStockInfoList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mallReport/getInStockInfo',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}